import { formatShortDate } from "@/util/date";

export function Time({ date }: { date: Date | number }) {
	const dateObj = new Date(date);
	return (
		<time dateTime={dateObj.toISOString()}>{formatShortDate(dateObj)}</time>
	);
}
